import { create } from 'zustand'
import type { IPassMinimumFields } from '../../../interfaces/src'

interface ModalCompleteProfileState {
  isOpen: boolean
  setIsOpen: ({
    isOpen,
    defaultDataForm
  }: {
    isOpen: boolean
    defaultDataForm?: IPassMinimumFields | undefined
  }) => void
  step: number
  setStep: (step: number) => void
  profileIsUpdated: boolean
  setProfileIsUpdated: (profileIsUpdated: boolean) => void
  form: {
    fullname: string | null
    email: string | null
    phoneNumber: string | null
    phoneCode: string | null
    gender: string | null
    birthdayYear: string | null
    birthdayMonth: string | null
    birthdayDay: string | null
    state: string | null
    city: string | null
    postalCode: string | null
    currentPosition: string | null
    taxId: string | null
    agencyName: string | null
    agencyPhone: string | null
  }
  getUserBirthday: () => string | null
  getPhoneNumber: () => string | null
  setForm: (form: any) => void
}

const initialState = {
  isOpen: false,
  step: 1,
  profileIsUpdated: false,
  form: {
    fullname: null,
    email: null,
    phoneNumber: null,
    phoneCode: '+52',
    birthdayYear: null,
    birthdayMonth: null,
    birthdayDay: null,
    gender: null,
    state: null,
    city: null,
    postalCode: null,
    currentPosition: null,
    taxId: null,
    userBirthday: null,
    agencyName: null,
    agencyPhone: null
  }
}

export const useModalCompleteProfileStore = create<ModalCompleteProfileState>()(
  (set, get) => ({
    ...initialState,
    setIsOpen: ({
      isOpen,
      defaultDataForm
    }: {
      isOpen: boolean
      defaultDataForm?: IPassMinimumFields | undefined
    }) =>
      set((state) => {
        if (defaultDataForm) {
          return {
            ...state,
            isOpen,
            form: {
              ...state.form,
              ...defaultDataForm
            }
          }
        }

        return {
          ...state,
          isOpen
        }
      }),
    setStep: (step) => set({ step }),
    setProfileIsUpdated: (profileIsUpdated) => set({ profileIsUpdated }),
    setForm: (dataForm) =>
      set((state) => ({
        form: {
          ...state.form,
          ...dataForm
        }
      })),
    getPhoneNumber: () => {
      const { phoneNumber, phoneCode } = get().form
      return `${phoneCode}${phoneNumber}`
        ?.replaceAll('-', '')
        ?.replaceAll('+', '')
    },
    getUserBirthday: () => {
      const { birthdayYear, birthdayMonth, birthdayDay } = get().form
      return `${birthdayYear}-${birthdayMonth}-${birthdayDay}`
    }
  })
)
